import { get } from 'lodash';

export const Env = {
  apiBaseUrl: get(window, 'evaluation.vars.apiBaseUrl', ''),
};
